import microuniversoApi from "app/api/microuniversoApi";
import { useAppSelector } from "app/redux/hooks";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { IOrcamento } from "app/types/IOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import { DefinirPrecoTintaRedux } from "app/use-cases/orcamento/itens/consultas/editarPrecoTintaNoOrcamento";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { useMenuConsultaProduto } from "../menu-consulta-produtos/useMenuConsultaProduto";
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { DadosCorante, DadosTinta, EditarPrecoTinta } from "./EditarPrecoTinta";


export type EditarPrecoTintaContainerProps = {
    item: IItemOrcamento,
    onRemover: () => void,
    onVoltar: () => void,
    passos: Dict<string, () => void>,
    somenteLeitura?: boolean,
    foraOrcamento: boolean
}

export const EditarPrecoTintaContainer = (props: EditarPrecoTintaContainerProps) => {
    const [usaRerenciaOuCodigo, setUsaReferenciaOuCodigo] = useState<string>("");

    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento);

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))    
    useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.map)), props.onVoltar, props.item, props.foraOrcamento)
    
    const corantes:DadosCorante[] = [];
    orcamento.ItensOrcamento.forEach(function (value) {
        if (value.CodigoTinta === props.item.CodigoTinta )  { //455868 || value.Referencia == props.item.Referencia) {
            corantes.push(value);
        }
    });
    const dadosTinta: DadosTinta = {
        nomeProduto: props.item.DescricaoProduto,
        corProduto: props.item.DescricaoCorTinta,
        precoUnitarioProduto: props.item.PrecoTinta,
        corantes: corantes
    }
    const DefinirPrecoTinta = async (Preco: number) => {

        globalMU.blockUI();
        try {
            await DefinirPrecoTintaRedux(props.item.Identificador, Preco, orcamento);
        }
        catch (erro) {
            tratamentoErroPadrao(erro);
        }
        finally {
            globalMU.unblockUI();
        }
        globalMU.showSuccessMessage("Preço tinta definido com sucesso");
        onVoltar()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        props.passos.get(passo)()
    }

    const PesquisaTrabalhaComCodigoOuReferenciaProduto = async () => {
        setUsaReferenciaOuCodigo(await microuniversoApi.Produto.trabalhaComCodigoOuReferencia());
    }

    useEffect(() => {
        passosInterno.current.set("Editar Preço Tinta",() => { renderizarComponentReact(<EditarPrecoTintaContainer {...props} />, "conteudo-pagina", true)  })
         PesquisaTrabalhaComCodigoOuReferenciaProduto();
    },[]);

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="EditarPrecoTintaContainer"
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}

            />

            <EditarPrecoTinta
                dadosTinta={dadosTinta}
                produtoUsaCodigoOuReferencia={usaRerenciaOuCodigo}
                onAplicar={DefinirPrecoTinta}
                somenteLeitura={props.somenteLeitura == null ? false : props.somenteLeitura}
            />
        </>
    );
}

